import type { ReportStats } from '@/types';

export const defaultStats: ReportStats = {
  impressions: {
    value: 0,
    percentage_change: 0,
  },
  reach: {
    value: 0,
    percentage_change: 0,
  },
  engagement_rate: {
    value: 0,
    percentage_change: 0,
  },
  cpm: {
    value: 0,
    percentage_change: 0,
  },
  cpe: {
    value: 0,
    percentage_change: 0,
  },
  cpr: {
    value: 0,
    percentage_change: 0,
  },
  total_interactions: {
    value: 0,
    percentage_change: 0,
  },
  sentiments: {
    positive: '0',
    neutral: '0',
    negative: '0',
  },
};

export const defaultPerformances = {
  label: [],
  data: {
    engagement_rate: [],
    impressions: [],
    reach: [],
  },
};

export const defaultAudienceData = {
  gender: {
    male: [],
    female: [],
  },
  age: {
    male: 0,
    female: 0,
  },
  country: [],
  interest: [],
};
